import * as React from "react";

import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        // MS204: was `text-sm` only. iOS Safari triggers an auto-
        // zoom-on-focus whenever a focused input/textarea has a
        // computed font-size below 16px — the canvas zooms in,
        // shifts the page, and the user has to pinch out to recover.
        // Match the `ui/input` pattern exactly: 16px on mobile to
        // dodge the zoom, 14px on md+ to keep the desk-class density.
        "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base md:text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
